// src/plugins/axios.js

import axios from "axios";
import { useUserStore } from "@/stores/user";
import { ElMessage } from "element-plus";

const apiClient = axios.create({
    baseURL: "/api", // Base URL for your API
    headers: {
        "Content-Type": "application/json",
    },
});

apiClient.interceptors.request.use(
    (config) => {
        const userStore = useUserStore();
        if (userStore.token) {
            config.headers.Authorization = `Bearer ${userStore.token}`;
        }
        return config;
    },
    (error) => {
        return Promise.reject(error);
    }
);

apiClient.interceptors.response.use(
    (response) => response,
    (error) => {
        // Centralized error handling for Requisicoes
        const config = error.config || {};
        const url = config.url || "";
        const method = (config.method || "").toLowerCase();
        // Only handle errors for POST, PATCH, PUT to /requisicoes
        if (
            url.includes("/requisicoes") &&
            ["post", "patch", "put"].includes(method)
        ) {
            const backendMsg = error.response?.data?.message;
            if (backendMsg) {
                ElMessage.error(backendMsg);
            } else {
                ElMessage.error("Erro ao criar requisição");
            }
        }
        return Promise.reject(error);
    }
);

export default apiClient;
